import { useCallback, useState } from 'react';

import { setToken } from 'services/api';
import constants from 'styles/constants';
import { emptyUser, User } from 'types/User';
import { GlobalContext, Auth } from './global';

export const useGlobalContext = (
  path?: string,
  host?: string,
  containerContext?: any,
): GlobalContext => {
  let token = '';
  let contextUser = emptyUser;

  if (containerContext) {
    token = containerContext.token;
    contextUser = containerContext.user;
  }

  const [user, setUser] = useState<User>(contextUser);
  const [auth, setAuth] = useState<Auth>({
    token,
  });
  const [hasContext, setHasContext] = useState<boolean>(!!containerContext);
  const [isMobile, setIsMobile] = useState<boolean>(
    global.window.innerWidth <= constants.screens.tablet.size,
  );

  if (containerContext) setToken(token);

  const setNewUser = useCallback((newUser: User) => setUser(newUser), []);
  const setNewAuth = useCallback((newAuth: Auth) => setAuth(newAuth), []);
  const setNewHasContext = useCallback(
    (newHasContext: boolean) => setHasContext(newHasContext),
    [],
  );

  global.window.addEventListener('resize', () => {
    const updatedIsMobile =
      global.window.innerWidth <= constants.screens.tablet.size;
    setIsMobile(updatedIsMobile);
  });

  return {
    hasContext,
    setHasContext: setNewHasContext,
    isMobile,
    path: path || '',
    host: host || '',
    containerContext: {
      user,
      setUser: setNewUser,
      auth,
      setAuth: setNewAuth,
    },
  };
};
